import { DnisCommandList } from '~/features/command-lists'

import { useFilterMutator } from '../hooks'

export function DnisFilterControl() {
  const { onSelect, selection } = useFilterMutator()
  return <DnisCommandList multiselect selected={selection} onSelect={onSelect} />
}
